import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useStoreActions } from '~/store/store-context';
export const useInvoiceDraftDates = function useInvoiceDraftDates(relationshipId) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.InvoiceDraftDates,
            relationshipId
        ],
        queryFn: ()=>api.invoiceDraft.getDates(relationshipId),
        enabled: !!relationshipId,
        refreshOnHookMount
    });
    return {
        invoiceDraftDates: data,
        isLoading
    };
};
